var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.649,
    height: 20.649,
    viewBox: "0 0 20.649 20.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    transform: "translate(6359.449 4831.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 9.825,
    cy: 9.825,
    r: 9.825,
    transform: "translate(-6358.949 -4831.21)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4362",
    "data-name": "Line 4362",
    y2: 8.32,
    transform: "translate(-6349.124 -4825.546)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4363",
    "data-name": "Line 4363",
    x1: 8.32,
    transform: "translate(-6353.284 -4821.386)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.915fdce3f8786fd2c7d615fc7dfe7b8f.svg";
export { ForwardRef as ReactComponent };